import $ from 'jquery';

export function initialize() {
    $('#make-link-and-share').tooltip()
}